import { z } from "zod";
/**
 * Machine-readable error codes. Every thrown domain error in the API maps to one of these
 * via GlobalExceptionFilter — this is the single source of truth for the appendix in API.md.
 */
export const ERROR_CODES = {
    // 400 — validation / malformed input
    validation_failed: 400,
    invalid_phone_number: 400,
    template_variables_missing: 400,
    csv_parse_failed: 400,
    // 401 — auth
    invalid_credentials: 401,
    invalid_totp_code: 401,
    token_expired: 401,
    token_invalid: 401,
    refresh_token_reused: 401, // family revoked, re-auth required
    // Distinct from token_invalid so an integrator can tell "my API key is bad" apart from
    // "my dashboard session expired" — they have completely different remedies.
    invalid_api_key: 401,
    email_not_verified: 401,
    // 403 — authorization
    insufficient_scope: 403,
    insufficient_role: 403,
    feature_not_available: 403,
    account_disabled: 403,
    device_limit_exceeded: 403,
    // 404
    not_found: 404,
    device_not_found: 404,
    message_not_found: 404,
    // 409 — conflict
    email_already_registered: 409,
    phone_already_registered: 409,
    device_already_paired: 409,
    duplicate_idempotency_key: 409,
    message_not_cancellable: 409,
    // 422 — semantically invalid domain state
    recipient_opted_out: 422,
    quiet_hours_blocked: 422,
    pairing_token_expired: 422,
    pairing_token_used: 422,
    // 429
    rate_limited: 429,
    quota_exceeded: 429,
    // 502 / 503 — dependency failures
    no_device_online: 503,
    fcm_delivery_failed: 502,
    webhook_target_blocked: 400,
    // 500
    internal_error: 500,
};
export const apiErrorBodySchema = z.object({
    error: z.object({
        code: z.custom((val) => typeof val === "string" && val in ERROR_CODES),
        message: z.string(),
        details: z.record(z.string(), z.unknown()).optional(),
        requestId: z.string(),
    }),
});
export class DomainError extends Error {
    code;
    details;
    constructor(code, message, details) {
        super(message);
        this.code = code;
        this.details = details;
        this.name = "DomainError";
    }
    get httpStatus() {
        return ERROR_CODES[this.code];
    }
}
//# sourceMappingURL=errors.js.map